import orderStatus from 'constants/orderStatus';
import { getCustomerAccount } from 'redux/modules/accounts/selectors/get-customer-account';
import { isJointOrMyWaitroseMember } from 'redux/modules/marketing-preferences/selectors/get-membership-status';
import { getOrder } from 'redux/modules/order/selectors';
import {
  getSlotBranchId,
  getSlotType,
} from 'redux/modules/order/selectors/get-order-slot-selectors';
import { getPartnerDiscountCardNumber } from 'redux/modules/order/selectors/partner-discount';
import getFirstSavedPaymentCard from 'redux/modules/payment/selectors/get-first-saved-payment-card';
import {
  canInstantCheckout,
  getInstantCheckoutReason,
} from 'redux/modules/trolley/selectors/can-instant-checkout';
import { getFeatureFlags } from 'utils/feature-flags';

export default (state: WtrState) => {
  const orderState = getOrder(state);

  const isAmend = orderState?.order?.status === orderStatus.AMENDING;
  const customerOrderId = orderState?.customerOrderId;
  const instantCheckoutEligibility = canInstantCheckout(state);
  const { id: customerId } = getCustomerAccount(state);
  const accountHasSavedCard = !!getFirstSavedPaymentCard(state);
  const slotType = getSlotType(state);
  const option = isAmend ? 'amend' : 'purchase';

  const { checkout_excludeExternal: excludeExternal } = getFeatureFlags() ?? {};

  // For server-side GA Measurement Protocol events
  const dataEvent = [];
  if (excludeExternal) {
    const slotBranchId = getSlotBranchId(state);
    const partnershipDiscount = getPartnerDiscountCardNumber(state);
    const membershipStatus = !!isJointOrMyWaitroseMember(state);

    dataEvent.push({
      event: undefined, // undefined so that the middleware does not set the type as the event and send it
      // common parameters for all events, as specified in GA4 implementation docs:
      //   https://johnlewispartnership.atlassian.net/wiki/spaces/WD/pages/621544687/Convert+existing+Checkout+events+to+Measurement+Protocol#The-Solution---MVP
      user: {
        customer_id: customerId, // uses session state
        branch_id: slotBranchId, // uses order state
        mywaitrose_customer: membershipStatus ? 'Y' : 'N', // uses membership state
      },
      partner_discount_status: partnershipDiscount ? 'active' : 'in-active', // uses order state
      instant_checkout_availability_reason: getInstantCheckoutReason(state), // uses trolley state
      instant_checkout_available: instantCheckoutEligibility, // uses trolley state
      instant_checkout_eligibility: instantCheckoutEligibility, // uses trolley state
    });
  }

  return [
    // first object sets session properties we want to persist and send with every event
    // These should already be in the session from the press of the checkout button, but
    // we set them again here to ensure they are present for later events - this might happen
    // if the checkout URL is loaded directly (e.g. via a bookmark or in Mobile Apps)
    ...dataEvent,
    {
      event: 'checkout_review_order',
      instant_checkout_eligibility: instantCheckoutEligibility,
      user: {
        customerId,
      },
      ecommerce: {
        checkout: {
          actionField: {
            option,
            id: customerOrderId,
            service_type: slotType,
            account_saved_card: accountHasSavedCard,
          },
        },
      },
    },
  ];
};
